export default "__VITE_ASSET__di9pPMhF__ 600w";